// extracted by mini-css-extract-plugin
export default {"ulmain":"User_ulmain__ZVdFT","h2":"User_h2__rYmt0","description":"User_description__9tTzn","item":"User_item__SuBA5","itemsub":"User_itemsub__YfFVA","main":"User_main__hQtMl"};